/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithTokenItemRequestBuilder, WithTokenItemRequestBuilderNavigationMetadata, WithTokenItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/public
 */
export interface PublicRequestBuilder extends BaseRequestBuilder<PublicRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.orders.public.item collection
     * @param token The opaque, encrypted share token from the URL path.
     * @returns {WithTokenItemRequestBuilder}
     */
     byToken(token: string) : WithTokenItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const PublicRequestBuilderUriTemplate = "{+baseurl}/api/orders/public";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PublicRequestBuilderNavigationMetadata: Record<Exclude<keyof PublicRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byToken: {
        requestsMetadata: WithTokenItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithTokenItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["token"],
    },
};
/* tslint:enable */
/* eslint-enable */
